export const APP_COLORS = {
  indigoSoftBackground: 'bg-indigo-50',
  indigoValueText: 'text-indigo-700',
  openedYesBadge: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  openedNoBadge: 'bg-slate-100 text-slate-600 ring-slate-200',
  bounceCodeInfoBadge: 'bg-sky-50 text-sky-700 ring-sky-200',
  bounceCodeWarningBadge: 'bg-amber-50 text-amber-700 ring-amber-200',
  bounceCodeErrorBadge: 'bg-red-50 text-red-700 ring-red-200',
} as const;

const STATUS_COLOR_MAP: Record<string, string> = {
  PAID: 'bg-green-100 text-green-800 ring-green-200',
  PENDING: 'bg-amber-100 text-amber-800 ring-amber-200',
  UNPAID: 'bg-amber-100 text-amber-800 ring-amber-200',
  CANCELED: 'bg-slate-200 text-slate-700 ring-slate-300',
};

export const getStatusBadgeClass = (status: string): string => {
  const normalizedStatus = status.toUpperCase();
  return STATUS_COLOR_MAP[normalizedStatus] ?? 'bg-indigo-100 text-indigo-800 ring-indigo-200';
};

const BOUNCE_TYPE_COLOR_MAP: Record<string, string> = {
  HARD_BOUNCE: 'bg-red-50 text-red-700 ring-red-200',
  SOFT_BOUNCE: 'bg-amber-50 text-amber-700 ring-amber-200',
  UNKNOWN: 'bg-slate-100 text-slate-700 ring-slate-200',
};

const BOUNCE_REASON_COLOR_MAP: Record<string, string> = {
  temporary_failure: 'bg-amber-50 text-amber-700 ring-amber-200',
  unclassified: 'bg-slate-100 text-slate-700 ring-slate-200',
  invalid_recipient: 'bg-red-50 text-red-700 ring-red-200',
};

const ACTION_COLOR_MAP: Record<string, string> = {
  failed: 'bg-red-50 text-red-700 ring-red-200',
  deferred: 'bg-amber-50 text-amber-700 ring-amber-200',
  delivered: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
};

export const getBounceTypeBadgeClass = (bounceType: string): string => {
  return BOUNCE_TYPE_COLOR_MAP[bounceType.toUpperCase()] ?? BOUNCE_TYPE_COLOR_MAP.UNKNOWN;
};

export const getBounceReasonBadgeClass = (bounceReason: string): string => {
  return BOUNCE_REASON_COLOR_MAP[bounceReason.toLowerCase()] ?? 'bg-slate-100 text-slate-700 ring-slate-200';
};

export const getBounceActionBadgeClass = (action: string): string => {
  return ACTION_COLOR_MAP[action.toLowerCase()] ?? 'bg-slate-100 text-slate-700 ring-slate-200';
};

export const getBounceCodeBadgeClass = (bounceCode: string): string => {
  if (bounceCode.startsWith('5')) return APP_COLORS.bounceCodeErrorBadge;
  if (bounceCode.startsWith('4')) return APP_COLORS.bounceCodeWarningBadge;
  return APP_COLORS.bounceCodeInfoBadge;
};